module.exports = __webpack_public_path__ + "img/arrow-right.34a8caa5.svg";